import type { Action, StoreActionApi } from 'react-sweet-state';
import { INITIAL_STATE } from '../../../../common/constants/state';
import { UPLOAD_CSV_STEP } from '../../../../common/constants/steps';
import type { State } from '../../../../common/types';

export type ResetStateAndReturnToUploadStepAction = () => Action<State, void, void>;

export const resetStateAndReturnToUploadStep =
	() =>
	({ setState, getState }: StoreActionApi<State>) => {
		/*
            We need to reset the state to initial state to avoid the scenarios where the import is started or partially
            started but errors occur and we try to reuse the same migrationId & file
        */
		const {
			projectData: { type },
		} = getState();
		setState({
			...INITIAL_STATE,
			step: UPLOAD_CSV_STEP,
			projectData: {
				...INITIAL_STATE.projectData,
				type,
			},
		});
	};
